define(function (require) {

    //Identifiant unique du module (miniscule, sans caractères spéciaux)
    var MODULE_ID = "quantaUpdate";

    /******************************************************/

    //Dépendences du module
    var quantamodule = require("quantamodule");
    var $ = require("jquery");
    var Promise = require("bluebird");

    /******************************************************/

    //Options par défaut
    var defaultOptions = {
        delayMs: 1000,
        onChange: function () { }
    }

    /******************************************************/

    //#region Methods
    function Methods($this) {

        function init() {//initialisation avec un objet d'options
            $this.state.timeoutHandle = null;
            $this.state.updatePending = false;

            //Pour trigger avec $("...").trigger("quantaupdate");
            $this.on("quantaupdate", $this.options.onChange);

            //keyup -> Pour contenteditable sous IE qui ne prend pas input
            $this.on("input keyup", function () {
                $this.state.updatePending = true;
                _onChange(false);
            });

            $this.on("change", function () {
                if ($this.state.updatePending) {
                    _onChange(true);
                }
            });
        }

        function initWithMethod(method) {//initialisation avec une méthode
            $this.options.onChange = method;
            init();
        }

        function _onChange(updateNow) {
            if ($this.state.timeoutHandle != null) {
                clearTimeout($this.state.timeoutHandle);
            }

            var delay = updateNow ? 0 : $this.options.delayMs;

            $this.state.timeoutHandle = setTimeout(function () {
                $this.state.updatePending = false;
                var onChangeResult = $this.options.onChange.call($this.get(0));
   
                if (onChangeResult != null) {
                    Promise.resolve(onChangeResult).then(function () {
                        //console.log("success");
                        //to do flash green
                    }).catch(function (ex) {
                        //console.log("fail " + ex.toString());
                        //to do red
                    });
                }

            }, delay);
        }

        return {
            init: init,
            initWithMethod: initWithMethod
        };
    };
    //#endregion


    /******************************************************/
    //#region Template Code
    $.fn[MODULE_ID] = quantamodule(MODULE_ID, defaultOptions, Methods);
    //#endregion
});
